import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.4997 13.1724L17.4495 8.22266L18.8637 9.63687L12.4997 16.0009L6.13574 9.63687L7.54995 8.22266L12.4997 13.1724Z",
		fill: "black"
	})
});
export default SvgIconArrowDown;
